import { useEffect, useState } from 'react';
import GlobalService from '../../../services/Global.service';
import { useParams } from 'react-router-dom';
import { Form } from 'antd';

export const ERROR_MSG_OTP_CASE = {
    // OTP not match.
    OPT_NOT_MATCH: 'OTP not match.',
    // OTP mistake more than 3 times.
    OTP_MISTAKE_MORE_THAN_3_TIMES: 'OTP mistake more than 3 times.',
    // OTP is expired.
    OTP_IS_EXPIRED: 'OTP is expired.',
    // OTP Transaction not found.
    OTP_TXN_NOT_FOUND: 'OTP Transaction not found.',
    // OTP already pass.
    OTP_ALREADY_PASS: 'OTP already pass.',
    // RefCode not match.
    REFCODE_NOT_MATCH: 'RefCode not match.',
    // Request OTP can call after 120 seconds again.
    REQUEST_OTP_AGAIN: 'Request OTP can call after 120 seconds again.',
};

export default function useOtp({ form, justPreview, refId }) {
    const { lang: lang_ = 'th' } = useParams();

    // OTP System
    const time = 120;
    const [disableOtp, setDisableOtp] = useState(true);
    const [count, setCount] = useState(time);
    const [isCountdown, setIsCountdown] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(false);
    const [isRequireOtp, setIsRequireOtp] = useState(false);
    const [refCode, setRefCode] = useState('');
    const [resultData, setResultData] = useState();
    const [isValidOtp, setIsValidOtp] = useState(false);

    const email = Form.useWatch('email', form);
    const otp = Form.useWatch('otp', form);

    const getOtp = async () => {
        try {
            const payload = {
                email: email,
                logoId: '',
                ownerId: refId,
            };
            const { data } = await GlobalService.getOtpByEmail(payload);
            if (data?.resultCode === 1) {
                const resultData = data?.resultData;
                setIsRequireOtp(true);
                setIsCountdown(true);
                setRefCode(resultData?.refCode);
                setResultData(resultData);
                setDisableOtp(false);
                form.resetFields(['otp']);
            }
        } catch (error) {
            setDisableOtp(true);
        }
    };

    // Verify OTP
    const verifyOtp = async () => {
        if (!otp)
            return form.setFields([
                {
                    name: 'otp',
                    errors: [
                        lang_ === 'th'
                            ? 'กรุณากรอกรหัส OTP'
                            : 'Please enter OTP.',
                    ],
                },
            ]);
        try {
            const payload = {
                email: email,
                otp: otp,
                refCode: refCode,
                otpTxnId: resultData?.otpTxnId,
            };
            const { data } = await GlobalService.verifyOtp(payload);
            let errors = [];

            if (data?.resultCode === 1) {
                setIsValidOtp(true);
                setCount(time);
                setIsCountdown(false);
                setIsRequireOtp(false);
            }

            if (data?.resultCode === 0) {
                const errorData = data?.errorData;
                const msg = errorData?.msg;
                const errorMessages = {
                    [ERROR_MSG_OTP_CASE.OPT_NOT_MATCH]:
                        lang_ === 'th'
                            ? 'รหัส OTP ไม่ถูกต้อง'
                            : 'OTP not match.',
                    [ERROR_MSG_OTP_CASE.OTP_MISTAKE_MORE_THAN_3_TIMES]:
                        lang_ === 'th'
                            ? 'รหัส OTP ไม่ถูกต้องเกินจำนวนครั้งที่กำหนด กรุณารับรหัสใหม่'
                            : 'OTP not match more than 3 times. Please get a new code.',
                    [ERROR_MSG_OTP_CASE.OTP_IS_EXPIRED]:
                        lang_ === 'th'
                            ? 'รหัส OTP หมดอายุ กรุณารับรหัสใหม่'
                            : 'OTP is expired. Please get a new code.',
                    [ERROR_MSG_OTP_CASE.OTP_TXN_NOT_FOUND]:
                        lang_ === 'th'
                            ? 'ไม่พบรหัส OTP กรุณารับรหัสใหม่'
                            : 'OTP not found. Please get a new code.',
                    [ERROR_MSG_OTP_CASE.OTP_ALREADY_PASS]:
                        lang_ === 'th'
                            ? 'รหัส OTP ถูกใช้งานแล้ว กรุณารับรหัสใหม่'
                            : 'OTP is already used. Please get a new code.',
                    [ERROR_MSG_OTP_CASE.REFCODE_NOT_MATCH]:
                        lang_ === 'th'
                            ? 'รหัสอ้างอิงไม่ถูกต้อง กรุณารับรหัสใหม่'
                            : 'RefCode not match. Please get a new code.',
                    [ERROR_MSG_OTP_CASE.REQUEST_OTP_AGAIN]:
                        lang_ === 'th'
                            ? 'ร้องขอรหัส OTP ได้หลังจาก 120 วินาที'
                            : 'Request OTP can call after 120 seconds again.',
                };
                errors = [errorMessages[msg]];
            }

            form.setFields([
                {
                    name: 'otp',
                    errors,
                },
            ]);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (isCountdown) {
            const interval = setInterval(() => {
                if (count > 0) {
                    setCount(count - 1);
                } else {
                    setCount(time);
                    setIsCountdown(false);
                    setIsRequireOtp(false);
                }
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [count, isCountdown]);

    useEffect(() => {
        if (justPreview) return;
        form.validateFields(['email'])
            .then(() => setIsValidEmail(true))
            .catch(() => setIsValidEmail(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email]);

    const disabledEmail = !email || !isValidEmail || isCountdown || isValidOtp;

    return {
        getOtp,
        verifyOtp,
        disableOtp,
        email,
        count,
        otp,
        isCountdown,
        isValidEmail,
        isRequireOtp,
        refCode,
        resultData,
        isValidOtp,
        disabledEmail,
        lang: lang_,
    };
}
